// src/components/HeroSection.jsx
import React from 'react';
import './HeroSection.css';
import {useNavigate} from "react-router-dom"

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <div className="hero-container" id='hero'>
      <div className="hero-overlay"></div>
      
      {/* Background image is handled in CSS for better performance and control */}

      <div className="hero-content">
        <h1 className="hero-title">
          <span className="animate-text-line">Transform your home with expert</span>
          <span className="animate-text-line">Renovation</span>
        </h1>
        <p className="hero-subtitle">
          With quality craftsmanship and transparent pricing, we make renovation simple and stress-free.
        </p>
        <button className="cta-button animated-pulse" onClick={()=>navigate("./services")}>
          Get Services
        </button>
      </div>
    </div>
  );
};

export default HeroSection;